import type {
  NativeQueryHistoryRequest,
  NativeQueryHistoryResponse,
} from "./types";

export const getNativeQueryHistory = async (
  request: NativeQueryHistoryRequest,
  signal?: AbortSignal,
) => {
  const searchParams = new URLSearchParams({
    scope: request.scope,
    limit: String(request.limit),
    offset: String(request.offset),
  });
  if (request.search) {
    searchParams.set("search", request.search);
  }

  const response = await fetch(`/api/jerry/query-history?${searchParams}`, {
    signal,
  });
  if (!response.ok) {
    throw new Error("Unable to load Native query history");
  }

  return (await response.json()) as NativeQueryHistoryResponse;
};
